// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HddFilledSvg from "@ant-design/icons-svg/es/asn/HddFilled";
import AntdIcon from '../components/AntdIcon';

var HddFilled = function HddFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: HddFilledSvg
  }));
};

HddFilled.displayName = 'HddFilled';
export default React.forwardRef(HddFilled);